export interface VespAsset {
  vesp_id: string;
  project_id: string | null;
  title: string;
  prompt: string;
  negative_prompt: string | null;
  category: string;
  model_name: string | null;
  aspect_ratio: string | null;
  media_type: string;
  params: string | null;
  tags: string | null;
  thumb_path: string;
  raw_file_name: string;
  file_size: number | null;
  mime_type: string | null;
  duration_sec: number;
  width: number | null;
  height: number | null;
  file_hash: string | null;
  phash: string | null;
  parent_vesp_id: string | null;
  sync_version: number;
  is_favorite: number;
  is_deleted: number;
  generated_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface ApiResponse<T> {
  code: number;
  data: T;
  total?: number;
}

export interface SearchParams {
  query?: string;
  category?: string;
  media_type?: string;
  model_name?: string;
  project_id?: string;
  is_favorite?: boolean;
  semantic?: boolean;
  limit?: number;
  offset?: number;
}

export interface LibraryStats {
  total: number;
  by_media_type: Record<string, number>;
  by_category: Record<string, number>;
  by_model: Record<string, number>;
  favorites: number;
  total_size: number;
}

/** 安全解析 JSON 字符串字段（tags/params），解析失败返回默认值 */
export function safeJsonParse<T>(raw: string | null | undefined, fallback: T): T {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}
